/*
 * @Author: chenxuelai 2251702447@qq.com
 * @Date: 2023-07-05 09:26:23
 * @LastEditors: chenxuelai 2251702447@qq.com
 * @LastEditTime: 2023-09-26 19:37:51
 * @FilePath: /vue_huaqiang/src/router/modules/mail-management.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import {RouteConfig} from "vue-router";
import Layout from "@/layout/index.vue";

const mailManagement: RouteConfig[] = [
    {
        path: "/mailsDetail",
        component: Layout,
        redirect: "mailsDetail",
        name: "mailsDetail",
        meta: {
            title: "mailsDetail",
            icon: "el-icon-s-comment",
        },
        children: [
            {
                path: "/mailsDetail",
                component: () => import("@/views/mail-management/MailManagement.vue"),
                name: "mailsDetail",
                meta: {title: "mailsDetail", icon: "el-icon-s-comment"}
            },
            {
                path: "/systemMailManagement",
                component: () => import("@/views/mail-management/SystemMailManagement.vue"),
                name: "systemMailManagement",
                meta: {title: "systemMailManagement", hidden: true}
            },
            {
                path: ":type/:documentId/documentFlow",
                name: "DocumentFlow",
                component: () =>
                    import("@/views/document-flow/DocumentFlow.vue"),
                meta: {title: "documentFlow", hidden: true},
            },
            {
                path: "/PIDetails",
                name: "PIDetails",
                component: () =>
                    import("@/views-oms/sales-order-management/order/pi-details/index.vue"),
                meta: {title: "PIDetails", hidden: true, activeMenu: "/salesOrder"}
            },
            {
                path: "/revisePI",
                name: "revisePI",
                component: () =>
                    import("@/views-oms/sales-order-management/order/pi-details/edit.vue"),
                meta: {title: "revisePI", hidden: true, activeMenu: "/salesOrder"}
            },
            {
                path: "/abnormalDeliveryHandling",
                name: "abnormalDeliveryHandling",
                component: () =>
                    import("@/views-oms/sales-order-management/order/abnormal-delivery-handling/index.vue"),
                meta: {title: "abnormalDeliveryHandling", hidden: true, activeMenu: "/salesOrder"}
            },
            {
                path: "/customerInventoryManagement",
                name: "customerInventoryManagement",
                component: () =>
                    import("@/views-oms/sales-order-management/order/customer-inventory/index.vue"),
                meta: {title: "customerInventoryManagement", hidden: true, activeMenu: "/salesOrder"}
            },
            {
                path: "/orderManagement",
                name: "orderManagement",
                component: () =>
                    import("@/views-oms/sales-order-management/order/order-management/index.vue"),
                meta: {title: "orderManagement", hidden: true, activeMenu: "/salesOrder"}
            },

            {
                path: "/orderDetails",
                name: "orderDetails",
                component: () =>
                    import("@/views-oms/sales-order-management/order/order-details/index.vue"),
                meta: {title: "orderDetails", hidden: true, activeMenu: "/salesOrder"}
            },
            {
                path: "/PIPaymentManagement",
                name: "PIPaymentManagement",
                component: () =>
                    import("@/views-oms/sales-order-management/order/pi-payment/index.vue"),
                meta: {title: "PIPaymentManagement", hidden: true, activeMenu: "/salesOrder"}
            },
            {
                path: "/quotationDetails",
                name: "quotationDetails",
                component: () =>
                    import("@/views-oms/sales-order-management/quotation/Details.vue"),
                meta: {title: "quotationDetails", hidden: true, activeMenu: "/quotationAudit"}
            },
            {
                path: "/editQuotation",
                name: "editQuotation",
                component: () =>
                    import("@/views-oms/sales-order-management/quotation/Edit.vue"),
                meta: {title: "editQuotation", hidden: true, activeMenu: "/quotationAudit"}
            },
            {
                path: "/otherExpensesManagement",
                component: () =>
                    import("@/views/hq-packing-list-management/other-expenses-management/index.vue"),
                name: "otherExpensesManagement",
                meta: {title: "otherExpensesManagement", hidden: true, activeMenu: '/factory-packing-list'},
            },
            // 创建付款单
            {
                path: "/createPaymentOrder",
                name: "createPaymentOrder",
                meta: { title: "createPaymentOrder", hidden: true, activeMenu: "/supplierPaymentManagement" },
                component: () =>
                    import("@/views-oms/financial-reconciliation-management/supplier-payment/create-payment/index.vue")
            },
            // 查看付款单详情
            {
                path: "/paymentOrderDetails",
                name: "paymentOrderDetails",
                meta: { title: "paymentOrderDetails" ,hidden: true, activeMenu: "/supplierPaymentManagement"},
                component: () =>
                    import("@/views-oms/financial-reconciliation-management/supplier-payment/order-details/index.vue")
            }
        ],
    }
];

export default mailManagement;
